import {Typography, styled} from '@mui/material';

export const FlatAppBarTitle = styled(Typography)(() => ({
  textAlign: 'center',
  width: '100%',
  color: 'white',
  fontWeight: 600,
  fontSize: 14,
}));
